import CityPageTemplate from "../city-template/CityPageTemplate";
import { menifeeConfig } from "./data";

export default function MenifeePage() {
  return <CityPageTemplate config={menifeeConfig} />;
}